App.Views.Forms.Settings = {};
